export enum SubmissionDataDetails {
  ApplicationData,
  SelectedProducts,
  ProductsData,
}
